export enum OperationParam {
  Undef = 0,
  Add = 1,
  Del = 2,
  List = 3,
  Get = 4,
  Update = 5
}
